/**
 * Утилиты для работы с обводкой элементов доски
 */
/**
 * Маппинг размеров обводки из логических значений в физические размеры
 * 1: 0.2; 2: 0.4; 3: 0.6; 4: 0.8; 5: 1; 6: 1.2; ...
 *
 * @param logicalWidth - Логическое значение ширины обводки
 * @returns Физический размер обводки для отрисовки
 */
export function mapStrokeWidth(logicalWidth) {
    if (typeof logicalWidth !== 'number' || isNaN(logicalWidth)) {
        return 1;
    }
    const width = Math.round(logicalWidth);
    return Math.max(0.2, width * 0.2);
}
